import { ReactElement, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';

import { EditAppointmentType } from 'RestAPIs/activities/types';

import { dialogActiveAtom } from '../../atoms';

import { ActionTooltip } from 'components/shared';

export interface Props {
  children?: ReactElement;
  open: boolean;
  isMultipleSelected?: boolean;
  onClose?: () => void;
  onClickAppointment:
    | ((editAppointment: EditAppointmentType) => void)
    | undefined;
}
export default function PopoverWarningDialog({
  children,
  open,
  isMultipleSelected,
  onClose,
  onClickAppointment
}: Props) {
  const { t } = useTranslation('common');
  const setDialogActive = useSetRecoilState<boolean>(dialogActiveAtom);

  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const isInitialMount = useRef<boolean>(false);

  const close = () => {
    onClose && onClose();
    setOpenDialog(false);
  };

  useEffect(() => {
    if (isInitialMount.current) {
      setOpenDialog(open);
      isInitialMount.current = false;
    } else if (open && !openDialog) {
      setOpenDialog(open);
    }

    // Emit global dialog event
    setDialogActive(open);
  }, [open]);

  // TODO: show time prop somewhere when time has a value
  return (
    <ActionTooltip
      title={
        isMultipleSelected
          ? t('activityPlanning.editRecurringAppointments')
          : t('activityPlanning.editRecurringAppointment')
      }
      open={openDialog}
      handleClose={close}
      actionButtons={[
        {
          label: isMultipleSelected
            ? `${t('activityPlanning.onlyTheseAppointments')}`
            : t('activityPlanning.onlyThisAppointment'),
          variant: 'outlined',
          onClick: () => {
            onClickAppointment && onClickAppointment('ONLY_THIS');
            setOpenDialog(false);
          }
        },
        {
          label: isMultipleSelected
            ? t('activityPlanning.theseAndSubsequentAppointments')
            : t('activityPlanning.thisAndSubsequentAppointments'),
          variant: 'outlined',
          onClick: () => {
            onClickAppointment && onClickAppointment('THIS_AND_ALL_SUBSEQUENT');
            setOpenDialog(false);
          }
        }
      ]}
    >
      {children || <></>}
    </ActionTooltip>
  );
}
